/**
 * @fileoverview
 * Search Component - Reusable search input component
 * Migrated to new architecture with OnPush change detection
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Component, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, Input, Output, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { debounce } from '@core/utils';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './search.component.html',
  styleUrl: './search.component.css'
})
export class SearchComponent implements OnInit, OnDestroy, OnChanges {
  @Input() value: string = '';
  @Output() searchChange = new EventEmitter<string>();
  
  searchValue: string = '';
  private isInternalChange = false;
  private debouncedEmit: (searchTerm: string) => void;
  private lastEmittedValue: string = '';

  constructor(private cdr: ChangeDetectorRef) {
    // Create debounced emit function using performance utils (500ms delay)
    this.debouncedEmit = debounce((searchTerm: string) => {
      // Only emit if value changed (distinctUntilChanged behavior)
      if (searchTerm !== this.lastEmittedValue) {
        this.lastEmittedValue = searchTerm;
        this.searchChange.emit(searchTerm);
      }
    }, 500);
  }

  ngOnInit(): void {
    this.searchValue = this.value || '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] && !this.isInternalChange) {
      this.searchValue = this.value || '';
      this.cdr.markForCheck();
    }
    this.isInternalChange = false;
  }

  ngOnDestroy(): void {
    // Cleanup: cancel any pending debounced calls
    // The debounce function handles cleanup internally via setTimeout
  }

  onInputChange(value: string): void {
    this.isInternalChange = true;
    this.searchValue = value;
    const trimmedValue = value.trim();
    this.debouncedEmit(trimmedValue);
    this.cdr.markForCheck();
  }
}
